<template>
  <div class="folder">
    <div class="titleFolder d-flex">
      <button class="btn btn-light mr-3" v-on:click="back()">
        <font-awesome-icon icon="arrow-left" class="mr-0" />
      </button>
      <div class="left w-50 d-flex justify-content-start align-items-center">
        <font-awesome-icon icon="folder-open" />
        <span>{{folder.name}}</span>
      </div>
      <div class="back w-50 d-flex justify-content-end align-items-center">

        <div v-if="folder.name === 'Fotos'" style="margin-right: 15px;">
          <GalleryDownloadProgress
            v-if="downloadProgress"
            :current="downloadProgress.current"
            :total="downloadProgress.total"
          />
          <b-dropdown v-else variant="link" no-caret toggle-class="p-0 text-dark text-decoration-none">
            <template v-slot:button-content>
              <font-awesome-icon icon="download" />Download Galeria
            </template>
            <b-dropdown-item @click="handleDownload(true)">Galeria HD</b-dropdown-item>
            <b-dropdown-item @click="handleDownload(false)">Galeria SD</b-dropdown-item>
          </b-dropdown>
        </div>

        <div class="uploadFile" v-on:click="openModal('upload-file')">
          <font-awesome-icon icon="upload" />Upload de Arquivo
        </div>

        <div class="deleteFolder" v-on:click="openModal('delete-folder-modal')">
          <font-awesome-icon icon="trash" />Deletar Pasta
        </div>
        <div class="return" v-if="folder.ancestor" v-on:click="openFolder(folder.ancestor.id)">
          <font-awesome-icon icon="angle-left" />Voltar
        </div>
      </div>
    </div>
    <b-modal ref="upload-file" title="Enviar Arquivo" @ok="handleSendFileWithFileName">
      <input type="text" v-model="newFileName" placeholder="Nome do arquivo" id class="form-control" />
      <br/>
      <b-form-file
        placeholder="Escolha um arquivo"
        drop-placeholder="Arraste o arquivo aqui..."
        browse-text="Procurar"
        accept="image/jpeg, image/png, image/jpg, application/pdf"
        v-on:change="handleFileSelect"
      ></b-form-file>
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Enviar</template>
      <br />
      <b-alert v-show="alert_field" :variant="alert_field_type" show>{{alert_field_msg}}</b-alert>
    </b-modal>

    <b-modal ref="delete-modal" title="Atenção" @ok="deleteFile()">
      <span>Tem certeza que deseja deletar este item?</span>
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Sim</template>
    </b-modal>
    <b-modal ref="delete-folder-modal" title="Atenção" @ok="deleteFolder()">
      <span>Tem certeza que deseja deletar esta pasta e todos seus arquivos?</span>
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Sim</template>
    </b-modal>
    <hr />
    <div class="container-fluid">
      <VueFullScreenFileDrop @drop="onDrop" text="Novo arquivo"></VueFullScreenFileDrop>
      <div class="photo-grid">
        <FolderGridItem
          v-for="subFolder in folder.descendants"
          :key="'folder-' + subFolder.id"
          ref="gridItem"
          :data-id="subFolder.id"
          type="folder"
          :name="subFolder.name"
          :id="subFolder.id"
          v-on:click.native="openFolder(subFolder.id)"
        />
        <FolderGridItem
          v-for="file in folder.attachments"
          :key="file.id"
          ref="gridItem"
          :data-id="file.id"
          type="file"
          :name="file.name"
          :id="file.id"
          :url="file.url"
          :mimeType="file.mime_type"
          :loaded="isItemLoaded(file.id)"
          canDelete
          v-on:click.native="handleFileClick(file)"
          @delete="deleteFileConfirm(file.id)"
        />
      </div>
    </div>
    <AttachmentViewer
      v-model="showImageModal"
      :attachments="folder.attachments"
      :startIndex="currentImageIdx"
      :showSelectButton="false"
    />
    <div style="justify-content: center;display: flex; align-items: center; font-size: 50px;margin:20px; color: #f2671c">
      <font-awesome-icon icon="file-pdf" class="mr-4"/>
      <font-awesome-icon icon="file-image" />
    </div>
    <div class="alertUpload">Arraste um arquivo até a tela para fazer upload</div>
  </div>
</template>
<script>
import axios from "@/api/axios";
import FolderGridItem from "@/components/FolderGridItem.vue";
import AttachmentViewer from "@/components/AttachmentViewer/AttachmentViewer.vue";
import GalleryDownloadProgress from "@/components/GalleryDownloadProgress.vue";
import { compressImage } from "@/utils/compressImage";
import { downloadGallery, getHdFallbackNotice } from "@/utils/downloadGallery";
import VueFullScreenFileDrop from "vue-full-screen-file-drop";
import "vue-full-screen-file-drop/dist/vue-full-screen-file-drop.css";

export default {
  name: "Folder",
  props: {
    folder_id: String,
    company_id: String,
    machine_id: String,
    machine_name: String
  },
  components: {
    FolderGridItem,
    VueFullScreenFileDrop,
    AttachmentViewer,
    GalleryDownloadProgress
  },
  data() {
    return {
      folder: { name: "" },
      itemToDelete: "",
      alert_field: false,
      alert_field_type: "success",
      alert_field_msg: "Item salvo com sucesso",

      newFileName: "",
      fileToUpload: null,
      showImageModal: false,
      currentImageIdx: null,

      loadedItems: {},
      gridObserver: null,

      downloadProgress: null,
    };
  },
  mounted() {
    this.getFolder();
  },
  beforeDestroy() {
    this.teardownGridObserver();
  },
  methods: {
    async handleDownload(hd) {
      try {
        const summary = await downloadGallery(this.folder.attachments, `${this.machine_name}`, {
          hd,
          onProgress: (progress) => {
            this.downloadProgress = progress;
          },
        });
        const notice = getHdFallbackNotice(summary);
        if (notice) {
          this.$bvToast.toast(notice, {
            title: "Download da galeria",
            toaster: "b-toaster-top-center",
            solid: true,
            variant: "warning",
            autoHideDelay: 8000,
          });
        }
      } finally {
        this.downloadProgress = null;
      }
    },

    handleFileSelect: async function (event) {
      const file = event.target.files[0];
      if (file) {
        this.fileToUpload = file;
      } else {
        this.fileToUpload = null; // Reset if no file selected
      }
    },

    uploadFile: async function(file){
      const loader = this.$loading.show();

      let renamedFile;

      if(file.type.startsWith("image/")){
        const compressedImage = await compressImage(file, 1, 1080, 720);
        const baseName = this.newFileName.length === 0
          ? compressedImage.name.replace(/\.[^/.]+$/, "") // remove extensão
          : this.newFileName;
        renamedFile = new File([compressedImage], baseName, { type: compressedImage.type });
      }else{
        const baseName = this.newFileName.length === 0
          ? file.name.replace(/\.[^/.]+$/, "") // remove extensão
          : this.newFileName;
        renamedFile = new File([file], baseName, { type: file.type });
      }
      const formData = new FormData();

      formData.append("file", renamedFile);
      formData.append("directory_id", this.folder_id);
      formData.append("company_id", this.company_id);
      formData.append("name", renamedFile.name);
      formData.append("machine_id", this.machine_id);

      await axios
        .postForm(`${process.env.VUE_APP_API_HOST}/api/admin/attachments/formdata`, formData)
        .then(() => {
          loader.hide();
          this.getFolder();
        })
        .catch(() => {
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger"
            }
          );
          loader.hide();
        });
    },
    back() {
      this.$router.replace({
        name: 'Company_Documents',
        params: { company_id: this.company_id },
        query: { machine_id: this.machine_id },
        replace: true
      });
    },
    getFolder: function() {
      const loader = this.$loading.show();
      axios
        .post(
          `${process.env.VUE_APP_API_HOST}/api/admin/get-attachments-by-machine`,
          { directory_id: this.folder_id, machine_id: this.machine_id }
        )
        .then(response => {
          this.folder = response.data;
          this.loadedItems = {};
          this.$nextTick(() => this.initGridObserver());
          loader.hide();
        })
        .catch(() => {
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger"
            }
          );
          loader.hide();
        });
    },
    addFile: function(file, fileName) {
      const loader = this.$loading.show();
      let x = file.split(",");
      axios
        .post(`${process.env.VUE_APP_API_HOST}/api/admin/attachments/`, {
          directory_id: this.folder_id,
          company_id: this.company_id,
          file: x[1],
          name: fileName,
          machine_id: this.machine_id
        })
        .then(() => {
          loader.hide();
          this.getFolder();
        })
        .catch(() => {
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger"
            }
          );
          loader.hide();
        });
    },
    openFolder: function(new_folder) {
      this.folder_id = new_folder;
      this.getFolder();
    },
    openModal: function(modal) {
      this.$refs[modal].show();
    },

    isValidFile: function(type) {
      return !(
        type != "image/jpeg" &&
        type != "application/pdf" &&
        type != "image/png"
      );
    },

    handleSendFileWithFileName: async function() {
      if(this.newFileName === ""){
        return this.$bvToast.toast(`Digite o nome do arquivo`, {
          title: `Ocorreu um erro`,
          toaster: "b-toaster-top-center",
          solid: true,
          variant: "danger"
        });
      }
      if( this.isValidFile(this.fileToUpload.type) ) {
        await this.uploadFile(this.fileToUpload).then(()=> this.newFileName = "");
      }else{
        this.newFileName = ""
        return this.$bvToast.toast(`São permitidos apenas imagens e arquivos PDF`, {
          title: `Ocorreu um erro`,
          toaster: "b-toaster-top-center",
          solid: true,
          variant: "danger"
        });
      }
    },

    async onDrop(formData, files) {
      let hasError = false;
      for (let i = 0; i < files.length; i++) {
        if (this.isValidFile(files[i].type)) {
          await this.uploadFile(files[i]);
        } else {
          hasError = true;
        }
      }
      if (hasError) {
        this.$bvToast.toast(`São permitidos apenas imagens e arquivos PDF`, {
          title: `Ocorreu um erro`,
          toaster: "b-toaster-top-center",
          solid: true,
          variant: "danger"
        });
      }
    },
    deleteFileConfirm: function(id) {
      this.openModal("delete-modal");
      this.itemToDelete = id;
    },
    deleteFile: function() {
      const loader = this.$loading.show();
      axios
        .delete(
          `${process.env.VUE_APP_API_HOST}/api/admin/attachments/${this.itemToDelete}`
        )
        .then(() => {
          loader.hide();
          this.getFolder();
        })
        .catch(() => {
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger"
            }
          );
          loader.hide();
        });
    },
    deleteFolder: function() {
      const loader = this.$loading.show();
      axios
        .delete(
          `${process.env.VUE_APP_API_HOST}/api/admin/directories/${this.folder_id}`
        )
        .then(() => {
          if (this.folder.ancestor) {
            loader.hide();
            this.openFolder(this.folder.ancestor.id);
          } else {
            loader.hide();
            // this.$router.go(-1);
            this.$router.replace({
              name: 'Company_Documents',
              params: { company_id: this.company_id },
              query: { machine_id: this.machine_id},
              replace: true
            });
          }
        })
        .catch(() => {
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger"
            }
          );
          loader.hide();
        });
    },
    handleFileClick(file) {
      if (file.mime_type && file.mime_type.startsWith("image/")) {
        // AttachmentViewer filtra attachments só pras imagens (imageFiles), então o
        // índice tem que ser calculado dentro desse subconjunto, não na lista cheia
        // (que mistura imagem e PDF) - senão abre a foto errada em pasta mista.
        const imageFiles = this.folder.attachments.filter(f => f.mime_type?.startsWith("image/"));
        this.currentImageIdx = imageFiles.findIndex(f => f.id === file.id);
        this.showImageModal = true;
      } else if (file.url) {
        window.open(file.url, "_blank");
      }
    },
    isItemLoaded(id) {
      return !!this.loadedItems[id];
    },
    initGridObserver() {
      this.teardownGridObserver();
      const els = this.$refs.gridItem || [];
      if (!els.length) return;

      if (!("IntersectionObserver" in window)) {
        els.forEach(vm => this.$set(this.loadedItems, vm.id, true));
        return;
      }

      this.gridObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const id = entry.target.dataset.id;
            if (id) this.$set(this.loadedItems, id, true);
            this.gridObserver.unobserve(entry.target);
          });
        },
        { root: null, rootMargin: "200px", threshold: 0.01 }
      );
      els.forEach(vm => this.gridObserver.observe(vm.$el));
    },
    teardownGridObserver() {
      if (!this.gridObserver) return;
      this.gridObserver.disconnect();
      this.gridObserver = null;
    },
  },
  watch: {
  },
  computed: {
  }
};
</script>
<style lang="scss">
.titleFolder {
  position: relative;
  padding: 15px 55px 0 25px;
  font-size: 20px;
  svg {
    margin-right: 0.8vw;
    color: #f2671c;
    font-size: 20px;
  }
  .deleteFolder {
    margin: 0 50px;
    svg {
      color: red;
    }
  }
  .uploadFile{
    cursor: pointer;
    svg {
      color: #f2671c;
    }
  }
  .deleteFolder:hover {
    cursor: pointer;
    svg {
      color: #ef4f4f;
    }
  }
  .return {
    margin-left: 4vw;
  }
  .return:hover {
    cursor: pointer;
  }
  .back {
    font-size: 16px;
  }
}
.alertUpload {
  display: flex;
  justify-content: center;
  font-size: 20px;
}
.photo-grid {
  display: grid;
  // auto-fill/minmax reage ao espaço realmente disponível pro grid, não à largura
  // da janela - a sidebar do DashboardLayout (200px) come parte dela, então um
  // breakpoint fixo por @media (max-width) erra a conta e mantém colunas demais
  // com a sidebar aberta. 190px dá 5-6 colunas nas larguras de tela mais comuns
  // (1280-1600px de conteúdo), reduzindo sozinho em telas menores.
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 16px;
  padding: 0 15px 20px;
}
</style>
